import axios from "axios";

/**
 * The message of a NestJS error response, validation errors come as a list
 */
export const getApiErrorMessage = (error: unknown): string | null => {
  if (!axios.isAxiosError(error)) {
    return null;
  }

  const message: unknown = error.response?.data?.message;
  if (Array.isArray(message)) {
    return message.join(", ");
  }

  return typeof message === "string" ? message : null;
};
